const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5000/api";
export async function fetchHackathonDetail(
  token: string,
  hackathonId: string
) {
  const res = await fetch(`${BASE}/hackathon-events/${hackathonId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Failed to fetch hackathon details");
 
  return data;
}
 
export async function registerForHackathon(
  token: string,
  payload: {
    hackathonId: string;
    teamName: string;
    leaderGrade: string;
    leaderRole: string;
    members: Array<{ name: string; email: string; grade: string; jobRole: string }>;
  }
) {
  const res = await fetch(`${BASE}/hackathon-register/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Registration failed");

  return data;
}

export async function checkHackathonRegistration(
  token: string,
  hackathonId: string
) {
  const res = await fetch(`${BASE}/hackathon-register/check/${hackathonId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Failed to check registration");

  return data;
}